import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const EngineeringDataWizardRoute: RouteType = {
  name: "EngineeringDataWizard",
  path: "/workflows/engineering-data",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Engineering Data Import",
      component: () => import("./EngineeringDataWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./EngineeringDataWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      const jobStore = rootStore.jobStore as ServiceStore;
      const billOfMaterialsStore = rootStore.billOfMaterialsStore as ServiceStore;
      const bomItemsStore = rootStore.bomItemsStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const bomExtractionStore = rootStore.bomExtractionStore as ServiceStore;

      await Promise.all([
        jobStore?.find(),
        billOfMaterialsStore?.find(),
        productsStore?.find(),
        bomExtractionStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for engineering data import:", error);
      return false;
    }
  },
};

export default EngineeringDataWizardRoute;